// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__u0XwY","stats__item":"Stats_stats__item__FJl-J","stats__value":"Stats_stats__value__2LHBF","stats__label":"Stats_stats__label__SIYiX"};